const ACTION_TYPES = {
    SIGN_IN: 'USER.SIGN_IN',
    UPDATE: 'USER.UPDATE',
    NOT_FOUND: 'USER.NOT_FOUND'
};

const initialState = {
    profileStatus: 0,
    isInitialized: false
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.UPDATE:
            return Object.assign({}, state, action.data);
        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
